<script>
import fieldMixin from '@maison/mixins/fieldMixin';
import { isEmpty } from 'lodash-es';
import { useField } from '@phoenix/composables/field';

export default {
  mixins: [fieldMixin],

  props: {
    parentId: {
      type: String,
      default: '',
    },
    extraClasses: {
      type: String,
      default: '',
    },
  },

  setup(props) {
    return useField(props);
  },

  computed: {
    radioClasses() {
      return [
        'switch switch--radio',
        this.extraClasses,
        {
          'switch--error': this.isInvalid,
          'switch--disabled': this.field.disabled,
        },
      ];
    },

    labelClasses() {
      return ['input-label switch__label radio-label', { 'input-label--error': this.isInvalid }];
    },

    ariaDescribedby() {
      return `${this.parentId}-label ${this.parentId}-error ${this.parentId}-help`;
    },

    inputValue() {
      return isEmpty(this.field.value) ? this.field.id : this.field.value;
    },

    inputId() {
      return `${this.parentId}-${this.fieldUniqueId}`;
    },
  },
};
</script>

<template>
  <div :class="radioClasses">
    <label :id="`${inputId}-label`" :for="inputId" :class="labelClasses">
      <slot name="label">
        <span class="input-label__text" v-html="field.label" />
      </slot>
    </label>

    <slot name="additionalContent" />

    <input
      :id="inputId"
      v-model="value"
      :value="inputValue"
      :name="field.name"
      :disabled="field.disabled"
      :aria-describedby="ariaDescribedby"
      type="radio"
      class="switch__input"
      :data-cy="attrs.dataCy"
    />
  </div>
</template>
